import React from 'react';
import { Building2 } from 'lucide-react';
import { propertyTypes } from '../../lib/constants';
import type { StepProps } from './types';

export default function PropertyTypeStep({ 
  formData, 
  handleInputChange,
  showPropertyTypeValidation
}: StepProps & { showPropertyTypeValidation?: boolean }) {
  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Type de bien*
        </label>
        <div className={`grid grid-cols-2 md:grid-cols-5 gap-3 relative ${showPropertyTypeValidation ? 'animate-pulse' : ''}`}>
          {showPropertyTypeValidation && (
            <div className="property-type-highlight" />
          )}
          {propertyTypes.map(({ value, label }) => (
            <label
              key={value}
              className={`
                flex flex-col items-center p-4 rounded-lg cursor-pointer border-2
                transition-all duration-300 hover:scale-[1.02]
                ${formData.type_propriete === value 
                  ? 'bg-gradient-to-r from-[#2A4365]/10 via-[#4A5568]/10 to-[#C4A052]/10 border-[#2A4365]' 
                  : 'bg-white border-gray-200 hover:bg-gradient-to-r hover:from-[#2A4365]/5 hover:via-[#4A5568]/5 hover:to-[#C4A052]/5'}
              `}
            >
              <input
                type="radio"
                name="type_propriete"
                value={value}
                checked={formData.type_propriete === value}
                onChange={handleInputChange}
                className="sr-only"
              />
              <Building2 
                className={`h-6 w-6 mb-2 transition-colors ${
                  formData.type_propriete === value 
                    ? 'text-[#2A4365]' 
                    : 'text-gray-400'
                } ${showPropertyTypeValidation ? 'animate-pulse' : ''}`} 
              />
              <span className={`text-sm ${
                formData.type_propriete === value 
                  ? 'text-[#2A4365] font-medium' 
                  : 'text-gray-700'
              }`}>{label}</span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
}